export default {
    'picking-out-the-points': {
      'course-name' : 'Section 1B <span class="unit-title">Cementing the Rules<span>',
      'course-title': 'Cementing the Rules',
      'course-video': {
        'title': 'Section 1 THE BASIC PYRAMID <br>21:09 -26:16 1B THE PYRAMID RULES <br>-: ex 1B cementing the rules + ex 1D Grasping the message <br>',
        'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
        'lecture-title': '1B Lecture'
      },
      'unit-section-title': '<span>1B Exercises</span>',
      'unit-exercise-description': `<p>
      If ideas are to fit into a pyramid structure under a single thought, they must obey general rules that define how the ideas should relate. These rules apply regardless of the subject of the document or the nature of the ideas.
      <ol class="ordered-list">
      <li>Ideas at any level must be summaries of the ideas grouped below them</li>
      <li>Ideas in each grouping must be logically the same</li>
      <li>Ideas in each grouping must be in logical order</li>
      </ol>
      <ul class="unordered-list">
        <li>Time order if they reflect a process</li>
        <li>Structural order if they comment on an existing structure</li>
        <li>Order of importance if they are the result of classifying</li>
      </ul>
      <br><p>Thus, before you begin to write, you can force your ideas into the pyramid form and test them against the rules. If any of the rules is broken, that signals your thinking is either invalid or incomplete, and you can repair the problem before you try to communicate.</p>

      <p>Following are the four examples you looked at earlier. In each case, the Original example broke one or more of the Minto Pyramid rules, which the Clearer example corrected.  Can you identify which rules were broken in each case.</p>
          <br>
        </p>`,
      'menu-list': {
        'exercise-1': 'Note to Mort',
        'exercise-2': 'Retail Price Data Survey',
        'exercise-3': 'Electronic Filing',
        'exercise-4': 'Perfect Team Size',
      },
      'exercise-one': {
        'exercise-number': '1B - Exercise 1',
        'exercise-title': 'Note to Mort',
        'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-1.jpg" alt="Original structure">',
        'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-2.jpg" alt="Original structure">',
      },
      'exercise-two': {
        'exercise-number': '1B - Exercise 2',
        'exercise-title': 'Retail Price Data Survey',
        'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-3.jpg" alt="Original structure">',
        'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-4.jpg" alt="Original structure">',
      },
      'exercise-three': {
        'exercise-number': '1B - Exercise 3',
        'exercise-title': 'Electronic Filing',
        'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-5.jpg" alt="Original structure">',
        'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-6.jpg" alt="Original structure">',
      },
      'exercise-four': {
        'exercise-number': '1B - Exercise 4',
        'exercise-title': 'Perfect Team Size',
        'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-7.jpg" alt="Original structure">',
        'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-8.jpg" alt="Original structure">',
      },
      'congratulation-message': 'THANK YOU',
      'finish-section': 'You have completed Section 1B',
      'final-description': 'You know the rules that govern how ideas must relate in a pyramid',
      'next-course-button': 'Proceed to 1C',
      'dashboard-button': 'Main menu',
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/1/1c/pickingOutThePoints/i18n/en.js